// Point d'entrée de la page : les pages publiques des invités (/r/… et /c/…, TRD §12 bis) ne chargent que leur petit paquet,
// sans l'app complète, sans le client Supabase ni les traductions des couples ; tout le reste charge l'app.
if (location.pathname.startsWith('/r/') || location.pathname.startsWith('/c/')) void import('./public/main.tsx');
else void import('./main.tsx');
